/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

/**
 * Toggles the data protection container visibility according to the terms & condition checkbox state
 */
function toggleDataProtectionContainerVisibility() {
    const isTermsAndConditionsChecked = document.getElementById('contact-terms-conditions')?.checked;
    if (isTermsAndConditionsChecked) {
        document.querySelector('.data-protection-info-container')?.classList.remove('d-none');
    } else {
        document.querySelector('.data-protection-info-container')?.classList.add('d-none');
    }
}

module.exports = {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (data.fields) {
                        var input;
                        data.fields.forEach(function (field) {
                            input = form.find('#contact-' + field);
                            input.addClass('is-invalid');
                            input.siblings('.invalid-feedback').text(input.attr('data-missing-error'));
                        });
                    }

                    displayMessage(data, button);
                    if (data.success) {
                        $('.contact-us').trigger('reset');
                    }
                },
                error: function (response) {
                    var message = 'Error';
                    if (response.responseJSON?.message && response.responseJSON.message !== 'undefined') {
                        message = response.responseJSON.message;
                    }
                    var data = {
                        succes: false,
                        msg: message
                    };
                    displayMessage(data, button);
                }
            });
        });
    },
    listenPrivacyPolicyCheck: function () {
        document.getElementById('contact-terms-conditions')?.addEventListener('change', toggleDataProtectionContainerVisibility);
    }
};
